import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {UPPERCASE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Driver's First Name text field.
 * Uppercases and sanitizes input on every keystroke.
 */
const DriverFirstNameField: React.FC<CheckInFieldProps> = ({value, onValueChange, error, required}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase());
    onValueChange('driverFirstName', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="driverFirstName"
      name="driverFirstName"
      label="Driver's First Name"
      value={value}
      onChange={handleChange}
      placeholder="Enter the driver's first name"
      variant="standard"
      fullWidth
      required={required}
      error={!!error}
      helperText={error}
      inputProps={{...UPPERCASE_INPUT_PROPS, 'aria-label': "Driver's First Name"}}
    />
  );
};

export default DriverFirstNameField;

